module.exports = __webpack_public_path__ + "img/Flag_of_Sri_Lanka.086777f1.svg";